const pref = [
    { localisedLabel: 'menu.preferences.name_public', key: "name_public" },
    { localisedLabel: 'sidebarMenu.preferences', key: "preferences" }
];

export default pref;